@if (tree.getDraft(id) !== null) {
<div id="scale-{{id}}" class="subdraft-parent-container selectable-{{!disable_drag}}" cdkDrag
  (click)="toggleMultiSelection($event)" [style.z-index]="zndx" [class.no-pointer]="disable_drag"
  [cdkDragDisabled]="disable_drag" (cdkDragMoved)="dragMove($event)" (cdkDragEnded)="dragEnd($event)"
  (cdkDragStarted)="dragStart($event)">
  <div class="topbar" (dblclick)="onDoubleClick()" [class.is_new]="isNew" cdkDragHandle>
    @if (ss.showComponentIds) {
    <div class="debug-id">ID: {{id}}</div>
    }
  </div>
  <app-draftcontainer #draftcontainer class="from_subdraft" [id]="id" [hasParent]="false"
    (connectionSelected)="connectionStarted($event)" (onOpenInEditor)="openInEditor($event)"
    (onDuplicateCalled)="designAction($event)" (onDeleteCalled)="designAction($event)"
    (onRecomputeChildren)="designAction($event)" (onNameChanged)="nameChange()"></app-draftcontainer>
</div>
}